import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react'

const ToolbarContext = createContext(null)

export function ToolbarProvider({ filters, children }) {
  const toolbarPropsRef = useRef(null)
  const [ready, setReady] = useState(false)

  const setToolbarProps = useCallback(
    (props) => {
      toolbarPropsRef.current = props
      if (!ready) setReady(true)
    },
    [ready]
  )

  const value = useMemo(() => ({ toolbarPropsRef, setToolbarProps, filters }), [setToolbarProps, filters])

  return <ToolbarContext.Provider value={value}>{children}</ToolbarContext.Provider>
}

export function useToolbarContext() {
  return useContext(ToolbarContext)
}
